import theme from '../theme'
import { makeStyles } from '@material-ui/core'

export const styleOverride = makeStyles({})

export const styleOverrideWithIcon = (
  colorSchema: 'primary' | 'secondary' | 'default',
  textSwitchConfig?: Record<string, unknown>
) =>
  makeStyles({
    root: {
      width: 57,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
      overflow: 'visible',
    },
    switchBase: {
      '&.MuiButtonBase-root': {
        position: 'absolute !important'
      },
      '&.MuiIconButton-root': {
        padding: '1px !important'
      },
      padding: 1,
      '&$checked': {
        transform: 'translateX(32px)',
        color: theme.palette.common.white,
        backgroundColor: textSwitchConfig
          ? 'transparent'
          : theme.palette[colorSchema].main,
        // this override the bar inside switch
        '& + $track':
          colorSchema === 'default'
            ? {
                backgroundColor: theme.palette.grey[400],
                opacity: 1,
              }
            : {},
      },
      '&$focusVisible $thumb': {},
    },
    thumb: {
      width: 26,
      height: 26,
      position: 'relative',
      top: '-1px',
      left: '-2px',
      boxShadow: 'none',
      backgroundColor: theme.palette[colorSchema].main,
    },
    track: {
      borderRadius: 26 / 2,
      // border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[400],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
      '&::before': textSwitchConfig
        ? {
            fontFamily: theme.typography.fontFamily,
            fontSize: '12px',
            position: 'relative',
            top: '3px',
            ...textSwitchConfig,
          }
        : undefined,
    },
    checked: {
      '&:hover': {
        backgroundColor:
          (textSwitchConfig ? 'transparent' : theme.palette[colorSchema].main) +
          ' !important',
      },
    },
  })
